<template>
  <div class="row">
    <div class="col-md-12">
      <table
        class="card table table-sm table-custom-primary table-bordered mb-0"
      >
        <tbody>
          <tr class="d-flex font-size-17 font-weight-bold">
            <td class="col-9">
              Fiche d'entretien de l'employé :
              {{
                currentEntretienIndividuel.header.employe.prenom
                  ? currentEntretienIndividuel.header.employe.prenom +
                    ' ' +
                    currentEntretienIndividuel.header.employe.nom
                  : currentEntretienIndividuel.header.employe.nom
              }}
            </td>
            <td class="col-3">
              Statut :
              <i
                class="mdi mdi-checkbox-blank-circle mr-1"
                :class="getClassOfEntretien(currentEntretienIndividuel.statut)"
              ></i>
              {{ getStatutEntretien(currentEntretienIndividuel.statut) }}
            </td>
          </tr>
          <tr class="d-flex font-size-17 font-weight-bold">
            <td class="col-7">
              Type d'entretien :
              {{ currentEntretienIndividuel.header.entretien_type.nom }}
            </td>
            <td class="col-5">
              Date et heure de l'entretien :
              {{ currentEntretienIndividuel.date_entretien }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    currentEntretienIndividuel: {
      require: true,
      type: Object,
    },
  },
};
</script>
